module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo logo-width",
    attrs: {
      "span": 20
    }
  }), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [(_vm.multiLanguage) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.setLang()
      }
    }
  }, [_vm._v(_vm._s(_vm.langToChange))]) : _vm._e(), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v(_vm._s(_vm.$t('logout')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c761b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderComponent.vue
// module id = 724
// module chunks = 0